import { useNavigate } from 'react-router-dom';

import BaseScreen from 'components/base-screen';
import { ButtonProps } from 'components/button';
import MainScreenContent from 'components/main-screen-content';

import { SellApartmentFlowPaths } from 'routes';

const SellApartmentMain: React.FC = () => {
  const navigate = useNavigate();

  const buttons: ButtonProps[] = [
    {
      label: 'Продать квартиру',
      onClick: () => navigate(SellApartmentFlowPaths.chooseApartmentComplex),
    },
  ];

  return (
    <BaseScreen padContent floatingButtons={false} title='Продажа квартиры' buttons={buttons}>
      <MainScreenContent />
    </BaseScreen>
  );
};

export default SellApartmentMain;
